export class CorrectionRequestService {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    async submit(input) {
        return this.apiClient.post('/work-sessions/corrections', input);
    }
    async listMine(accountId, status) {
        const params = { account_id: accountId };
        if (status)
            params.status = status;
        return this.apiClient.get('/work-sessions/corrections', params);
    }
    /** Reviewer inbox (work_sessions:edit). status 'all' lists everything. */
    async listForLocation(locationId, status) {
        const params = {};
        if (status)
            params.status = status;
        return this.apiClient.get(`/locations/${locationId}/corrections`, params);
    }
    /** Account-wide reviewer inbox across locations (work_sessions:edit). */
    async listForAccount(accountId, status) {
        const params = {};
        if (status && status !== 'all')
            params.status = status;
        return this.apiClient.get(`/accounts/${accountId}/corrections`, params);
    }
    async approve(requestId, notes) {
        return this.apiClient.post(`/corrections/${requestId}/approve`, notes ? { notes } : {});
    }
    async reject(requestId, notes) {
        return this.apiClient.post(`/corrections/${requestId}/reject`, { notes });
    }
    async cancel(requestId) {
        return this.apiClient.post(`/corrections/${requestId}/cancel`);
    }
    async getEfficiency(input) {
        return this.apiClient.post('/reports/efficiency/data', input);
    }
    async exportPayroll(input) {
        return this.apiClient.post('/reports/payroll-export', input);
    }
}
